// extracted by mini-css-extract-plugin
module.exports = {"plan":"Plan_plan__mSKny","plan__highlightText":"Plan_plan__highlightText__sSVsg","plan__icon":"Plan_plan__icon__FkMVq","plan__bestSelling":"Plan_plan__bestSelling__3FAq4"};